import { render } from "./OffenePositionen.vue?vue&type=template&id=61b970e0"
import script from "./OffenePositionen.vue?vue&type=script&lang=ts"
export * from "./OffenePositionen.vue?vue&type=script&lang=ts"

import "./OffenePositionen.vue?vue&type=style&index=0&id=61b970e0&lang=scss"
script.render = render

export default script